<div class="row">
    <div class="col-24">
        <h3>License Information</h3>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <table class="table-text-small licence-table">
            <thead>
                <tr>
                    <th>State</th>
                    <th>State License #</th>
                    <th>License Expiration Date(mm/dd/yyyy)</th>
                    <th>License Status</th>
                    <th>Source</th>
                    <th *ngIf="showAppt">Record Locked</th>
                    <th *ngIf="showAppt">Appointment Status</th>
                    <th *ngIf="showAppt">Appointment Data Source</th>
                    <th *ngIf="showAppt">Appointment Date</th>
                    <th *ngIf="showAppt">Appointment Termination Date</th>
                    <!--<th *ngIf="superGuruAdmin">Actions</th>-->
                    <th *ngIf="showActions">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let l of licenseViewModel; let i = index; trackBy: trackLicenseViewModel">
                    <td>
                        {{l.StateAbbr}}
                    </td>
                    <td>
                        <div *ngIf="l.EditRow && index==i;else other_content_licenseNumber">

                        </div>

                        <ng-template #other_content_licenseNumber>{{l.LicenseNumber}}</ng-template>

                        <input type="text" name="LicenseNumber{{i}}" id="LicenseNumber{{i}}"
                            [(ngModel)]="licenseViewModel[i].LicenseNumber" *ngIf="l.EditRow && index==i"
                            value="{{l.LicenseNumber}}" />
                    </td>
                    <td>
                        <div *ngIf="l.EditRow && index==i;else other_content_licenseExpirationDate">

                        </div>

                        <ng-template #other_content_licenseExpirationDate>{{l.LicenseDate}}</ng-template>
                        <input type="text" name="LicenseExpirationDate{{i}}" helperText="Format as MM/DD/YYYY"
                            id="LicenseExpirationDate{{i}}" [(ngModel)]="licenseViewModel[i].LicenseDate"
                            *ngIf="l.EditRow && index==i" value="{{l.LicenseDate}}" />

                    </td>
                    <td>
                        <div *ngIf="l.EditRow && index==i;else other_content_licenseStatusId">

                        </div>

                        <ng-template #other_content_licenseStatusId>{{l.Status}}</ng-template>


                        <select name="LicenseStatusId{{i}}" id="LicenseStatusId{{i}}"
                            [(ngModel)]="licenseViewModel[i].Status" *ngIf="l.EditRow && index==i">
                            <option *ngFor="let licStatus of allLicenseStatus; trackBy: trackAllLicenseStatus"
                                [value]="licStatus.LicenseStatus">
                                {{licStatus.LicenseStatus}}
                            </option>
                        </select>

                    </td>
                    <td>{{l.DataSource}}</td>
                    <td *ngIf="showAppt">
                        <input type="checkbox" class="option__input" name="RecordLocked{{i}}" id="RecordLocked{{i}}"
                            disabled="{{l.checkboxDisable}}" [(ngModel)]="licenseViewModel[i].RecordLocked" />
                        <label for="RecordLocked{{i}}"></label>

                    </td>
                    <td *ngIf="showAppt">{{l.AppointmentStatusName}}</td>
                    <td *ngIf="showAppt">{{l.Source}}</td>
                    <td *ngIf="showAppt">{{l.Effectivedate}}</td>
                    <td *ngIf="showAppt">{{l.ExpirationDate}}</td>
                    <!--<td *ngIf="superGuruAdmin">-->
                    <td *ngIf="showActions">

                        <button id="delete" (click)="deleteLicense(l.LicenseID, l.UserProfileID)">Delete</button>
                        <button id="edit" (click)="editLicense(l.LicenseID, i,l.LicenseNumber,l)"
                            *ngIf="!l.EditRow">Edit</button>
                        <button id="save" (click)="saveRowLicense(licenseViewModel[i],i)"
                            *ngIf="l.EditRow && index==i">Save</button>
                        <button id="appoint"
                            (click)="appointLicense(l.LicenseID, l.UserProfileID,l.AppointmentStatusName)"
                            *ngIf="l.appoint">Appoint</button>
                        <button id="confirmappoint" (click)="confirmappointLicense(l.LicenseID, l.UserProfileID)"
                            *ngIf="l.cfmappoint">Confirm Appointment</button>
                        <button id="terminate" (click)="terminateLicense(l.LicenseID, l.UserProfileID)"
                            *ngIf="l.terminate">Terminate</button>
                        <button id="cfmterminate" (click)="cfmterminateLicense(l.LicenseID, l.UserProfileID)"
                            *ngIf="l.cfmterminate">Confirm Termination</button>
                    </td>
                </tr>
                <tr *ngIf="saveRow">
                    <td>
                        <div class="input-wrapper">
                            <ValidatedDropDown class="" [label]="''" [disabled]="'false'" [options]="allStates"
                                (onValueChange)="licenseInsertModel.StateAbbr= $event">
                            </ValidatedDropDown>
                        </div>

                    </td>
                    <td>
                        <div class="input-wrapper">
                            <ValidatedTextField class="" [label]="''" id="LicenseNumber"
                                [text]="licenseInsertModel.LicenseNumber"
                                (onValueChange)="licenseInsertModel.LicenseNumber = $event">
                            </ValidatedTextField>
                        </div>
                        <!--
                                                    <input type="text" [(ngModel)]="licenseInsertModel.LicenseNumber" id="LicenseNumber" name="LicenseNumber" />
                        -->
                    </td>
                    <td>
                        <div class="input-wrapper">
                            <ValidatedTextField class="" [label]="''" id="LicenseExpirationDate"
                                [text]="licenseInsertModel.LicenseExpirationDate"
                                (onValueChange)="licenseInsertModel.LicenseExpirationDate = $event">
                            </ValidatedTextField>
                        </div>
                        <!--
                            <input type="text" [(ngModel)]="licenseInsertModel.LicenseExpirationDate" id="LicenseExpirationDate" name="LicenseExpirationDate" placeholder="mm/dd/yyyy" />
                        -->
                    </td>
                    <td>
                        <div class="input-wrapper">
                            <ValidatedDropDown class="" [label]="''" [disabled]="'false'"
                                [options]="licenseStatusDropDown"
                                (onValueChange)="licenseInsertModel.LicenseStatusId= $event">
                            </ValidatedDropDown>
                        </div>

                        <!--
                        <select [(ngModel)]="licenseInsertModel.LicenseStatusId" id="LicenseStatusId" name="LicenseStatusId">
                            <option *ngFor="let licStatus of allLicenseStatus" value={{licStatus.LicenseStatusID}}>
                                {{licStatus.LicenseStatus}}
                            </option>
                        </select>
                            -->
                    </td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                    <td *ngIf="showAppt"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div>
    <input type="checkbox" class="option__input" id="recordlocked" />
</div>
<div class="row">
    <!--<div class="col-24" *ngIf="superGuruAdmin || orgAdminMngr">-->
    <div class="col-24" *ngIf="showActions">
        <button id="addRow" (click)="addNewRow()" *ngIf="!saveRow" [disabled]="this._global.currentUser.isAuditor"
            class="button primary">Add New Row</button>
        <button id="saveNewRow" (click)="saveLicense()" *ngIf="saveRow" [disabled]="this._global.currentUser.isAuditor"
            class="button primary">Save License</button>
        <button id="cancelNewRow" (click)="cancelLicense()" *ngIf="saveRow" class="button cancel">Cancel</button>
    </div>
</div>
<div class="row">
    <div class="col-24" *ngIf="showMessage">
        <div class="alert success">
            {{savedMessage}}
        </div>
    </div>

    <div class="col-24" *ngIf="!validLicenseForm">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of errorMessagesForm"><button>{{error}}</button></li>
            </ul>
        </div>
    </div>

</div>
<div class="row">
    <div class="col-24" *ngIf="showConfirmDelete">
        <!--<div>
            <strong>
                <a id="lnkCancel" (click)="cancelStatusUpdate()" >X</a>
            </strong>
        </div>-->
        <div class="action-required">
            <div id="messagedel">
                <p id="currentDate" class="heading">{{displayMessage}}</p>
            </div>
            <button class="button primary" name="btnDeleteConfirm" [disabled]="this._global.currentUser.isAuditor"
                id="DeleteConfirm" *ngIf="updateLicense" (click)="updateLicenseStatus()">Confirm</button>
            <button class="button primary" id="delete" *ngIf="!updateLicense"
                [disabled]="this._global.currentUser.isAuditor" (click)="deleteLicenseData()">Confirm Delete</button>
            <button class="button cancel" id="lnkCancelBtn" (click)="cancelStatusUpdate()">Cancel</button>
        </div>
    </div>
</div>
<button #focusableEleBottom class="focusable-element"></button>